import React from 'react'
import { Grid, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import InputField from '../../../../FormControl/input/InputField'

const FormLevels = ({ onChangeAlert }) => {
  const formData = useSelector((state) => state?.lc?.form?.levels || {})

  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const [form, setInputForm] = React.useState(formData)
  const [errors, setInputErrors] = React.useState({})

  if (!currentCurriculum || !currentCurriculum?.levels) return <></>

  const onChange = (name, value) => {
    const formData = { ...form, [name]: value }
    setInputForm({ ...form, ...formData })
    setInputErrors({ ...errors, [name]: null })
    onChangeAlert('levels', formData)
  }

  return (
    <Grid container spacing={2}>
      {currentCurriculum?.levels?.sort((a, b) => a.position - b.position)?.map((item) => (
        <React.Fragment key={item._id}>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
              {item?.name}
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            <InputField
              id={`${item?._id}`}
              name={item?._id}     
              className='capitalize'
              error={errors[item?._id]}
              helperText={errors[item?._id]}                    
              value={form[item?._id]}
              multiline={true }
              onChange={(e) => onChange(item?._id, e.target.value)}      
            />
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  )
}

export default FormLevels